import React from 'react'
import { DownloadsParent } from 'src/Libs/downloads/models/downloads.model'
import { SxProps } from '@mui/system'
import { Box, IconButton } from '@mui/material'
import UserLevelTag from './UserLevelTag'
import { J1RightarrowD, J2Folder } from '@e3dc-react/icons'
import { makeStyles } from 'tss-react/mui'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { DownloadCategoryItemDto } from '../dto'
import { useCategoryDisplayName } from '../hooks'

const useStyles = makeStyles<{ isRootLevel?: boolean }>()((theme, props) => ({
  root: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    minHeight: 72,
    paddingLeft: theme.spacing(4),
    overflow: 'hidden',
    cursor: 'pointer',
    boxShadow: props.isRootLevel ? theme.effectStyles.shadowMain : 'none',
    display: 'grid',
    alignItems: 'center',
    gridTemplateRows: '1fr',
    columnGap: theme.spacing(2),
    rowGap: 0,
    [theme.breakpoints.up('xs')]: {
      gridTemplateColumns: 'auto 1fr 30px',
    },
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '30px 1fr 1fr 110px',
    },
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '30px 2fr 1fr 110px',
    },
  },
}))

interface CategoryNodeProps {
  category: DownloadCategoryItemDto
  sx?: SxProps
  isServiceUser?: boolean
  onSelectCategory: (categoryId?: number) => void
  parent?: DownloadsParent
  isRootLevel?: boolean
}

/**
 * CategoryNode component displays a single category in the downloads list
 */
const CategoryNode: React.FC<CategoryNodeProps> = ({ category, isServiceUser, onSelectCategory, parent, sx, isRootLevel }) => {
  const onSelect = (): void => onSelectCategory(category.id)
  const getCategoryDisplayName = useCategoryDisplayName()
  const { classes } = useStyles({ isRootLevel })

  return (
    <Box sx={sx} className={classes.root} onClick={onSelect} data-qa={`category-node-${category.id}`}>
      <Box sx={{ gridColumn: '1', display: 'flex', alignItems: 'center' }}>
        <J2Folder />
      </Box>
      <Box sx={{ gridColumn: '2', overflow: 'hidden' }}>
        <Typography variant="h3" noWrap>
          {getCategoryDisplayName(category.nameLanguages)}
        </Typography>
      </Box>
      <Box sx={{ gridColumn: { xs: '1 / 3', sm: '3' }, overflow: 'hidden' }}>
        {isServiceUser && <UserLevelTag isVisibleInstallerPartner={category.visibleToInstaller} isVisibleUser={category.visibleToCustomer} />}
      </Box>
      <Box sx={{ gridColumn: { xs: '3', sm: '4' }, gridRow: { xs: '1 / 3', sm: '1' }, justifySelf: 'end' }}>
        <IconButton onClick={onSelect}>
          <J1RightarrowD />
        </IconButton>
      </Box>
    </Box>
  )
}

export default CategoryNode
